export default {
    sound(url) {
        const audio = new Audio(url);
        audio.play()
    },
};
